module.exports = __webpack_public_path__ + "media/images/przedszkole2-0c6f8a4d6725760c5e84b34d509eeb9c.png";